import {
  SET_CLAIM_FORM_DATA,
  SET_CLAIM_FORM_STATUS,
  RESET_CLAIM_FORM,
  SUBMIT_CLAIM_FORM,
  SUBMIT_CLAIM_FORM_SUCCESS,
  SUBMIT_CLAIM_FORM_ERROR,
  SET_CONSULTATION_FORM_DATA,
  SET_CONSULTATION_FORM_STATUS,
  RESET_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM,
  SUBMIT_CONSULTATION_FORM_SUCCESS,
  SUBMIT_CONSULTATION_FORM_ERROR,
  SET_REGRET_FORM_DATA,
  SET_REGRET_FORM_STATUS,
  RESET_REGRET_FORM,
  SUBMIT_REGRET_FORM,
  SUBMIT_REGRET_FORM_SUCCESS,
  SUBMIT_REGRET_FORM_ERROR,
} from '../actions/action-types';

const initialState = {
  claimForm: {
    data: {
      direccion: '',
      departamento: '',
      provincia: '',
      distrito: '',
      telefonoFijo: '',
      telefonoCelular: '',
      email: '',
      bienContratado: '',
      montoReclamado: '',
      descripcion: '',
    },
    status: 'idle', // 'idle', 'sending', 'success', 'error'
    isSubmitting: false,
    error: null,
    submitResult: null,
  },
  consultationForm: {
    data: {
      nombre: '',
      email: '',
      telefono: '',
      asunto: '',
      mensaje: '',
    },
    status: 'idle',
    isSubmitting: false,
    error: null,
    submitResult: null,
  },
  regretForm: {
    data: {
      numeroReserva: '',
      motivo: '',
      descripcion: '',
      nombre: '',
      email: '',
      telefono: '',
    },
    status: 'idle',
    isSubmitting: false,
    error: null,
    submitResult: null,
  },
};

const formsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Claims Form
    case SET_CLAIM_FORM_DATA:
      return {
        ...state,
        claimForm: {
          ...state.claimForm,
          data: {
            ...state.claimForm.data,
            ...action.payload,
          },
        },
      };

    case SET_CLAIM_FORM_STATUS:
      return {
        ...state,
        claimForm: {
          ...state.claimForm,
          status: action.payload,
        },
      };

    case SUBMIT_CLAIM_FORM:
      return {
        ...state,
        claimForm: {
          ...state.claimForm,
          isSubmitting: true,
          error: null,
        },
      };

    case SUBMIT_CLAIM_FORM_SUCCESS:
      return {
        ...state,
        claimForm: {
          ...state.claimForm,
          isSubmitting: false,
          submitResult: action.payload,
          error: null,
        },
      };

    case SUBMIT_CLAIM_FORM_ERROR:
      return {
        ...state,
        claimForm: {
          ...state.claimForm,
          isSubmitting: false,
          error: action.payload,
        },
      };

    case RESET_CLAIM_FORM:
      return {
        ...state,
        claimForm: initialState.claimForm,
      };

    // Consultation Form
    case SET_CONSULTATION_FORM_DATA:
      return {
        ...state,
        consultationForm: {
          ...state.consultationForm,
          data: {
            ...state.consultationForm.data,
            ...action.payload,
          },
        },
      };

    case SET_CONSULTATION_FORM_STATUS:
      return {
        ...state,
        consultationForm: {
          ...state.consultationForm,
          status: action.payload,
        },
      };

    case SUBMIT_CONSULTATION_FORM:
      return {
        ...state,
        consultationForm: {
          ...state.consultationForm,
          isSubmitting: true,
          error: null,
        },
      };

    case SUBMIT_CONSULTATION_FORM_SUCCESS:
      return {
        ...state,
        consultationForm: {
          ...state.consultationForm,
          isSubmitting: false,
          submitResult: action.payload,
          error: null,
        },
      };

    case SUBMIT_CONSULTATION_FORM_ERROR:
      return {
        ...state,
        consultationForm: {
          ...state.consultationForm,
          isSubmitting: false,
          error: action.payload,
        },
      };

    case RESET_CONSULTATION_FORM:
      return {
        ...state,
        consultationForm: initialState.consultationForm,
      };

    // Regret Form
    case SET_REGRET_FORM_DATA:
      return {
        ...state,
        regretForm: {
          ...state.regretForm,
          data: {
            ...state.regretForm.data,
            ...action.payload,
          },
        },
      };

    case SET_REGRET_FORM_STATUS:
      return {
        ...state,
        regretForm: {
          ...state.regretForm,
          status: action.payload,
        },
      };

    case SUBMIT_REGRET_FORM:
      return {
        ...state,
        regretForm: {
          ...state.regretForm,
          isSubmitting: true,
          error: null,
        },
      };

    case SUBMIT_REGRET_FORM_SUCCESS:
      return {
        ...state,
        regretForm: {
          ...state.regretForm,
          isSubmitting: false,
          submitResult: action.payload,
          error: null,
        },
      };

    case SUBMIT_REGRET_FORM_ERROR:
      return {
        ...state,
        regretForm: {
          ...state.regretForm,
          isSubmitting: false,
          error: action.payload,
        },
      };

    case RESET_REGRET_FORM:
      return {
        ...state,
        regretForm: initialState.regretForm,
      };

    default:
      return state;
  }
};

export default formsReducer;
